<template>
  <component :is="type" class="dea-button" v-on="$listeners">
    <span
      v-if="icon && !isSvg(icon)"
      class="icon dea-button__icon"
      :class="getIcon(icon)"
      :aria-label="`icona${icon}`"
    ></span>
    <svg-img-icon
      v-if="icon && isSvg(icon)"
      class="icon dea-button__icon dea-button__icon--svg"
      :name="icon"
      :aria-label="icon.replace('.svg', '')"
    />
    <span class="dea-button__label">
      <slot />
    </span>
  </component>
</template>

<script>
/**
 * I pulsanti sono stati rappresentati con un numero di stili predefiniti per la maggior parte dei casi d'uso. I pulsanti possono avere diversi scopi, dallo styling dei collegamenti ipertestuali per formare pulsanti funzionali utilizzando una varietà di dimensioni, colori e combinazioni di icone. Se gli stili di visualizzazione dei pulsanti vengono utilizzati per le operazioni funzionali basate sulla pagina, i pulsanti per l'invio o le interazioni di moduli, è necessario utilizzare il tag HTML 'button'. Il dimensionamento dei pulsanti deve essere gestito con le classi pertinenti, garantendo il miglior risultato di visualizzazione tra i dispositivi.
 */
import SvgImgIcon from "@/components/elements/SvgImgIcon";

export default {
  name: "Buttons",
  components: { SvgImgIcon },
  props: {
    type: {
      type: String,
      default: "button",
    },
    icon: {
      type: String,
      default: "",
    },
  },
  methods: {
    getIcon(icon) {
      return `dea-ico-${icon}`;
    },
    isSvg(icon) {
      return icon.endsWith(".svg");
    },
  },
};
</script>
